// extracted by mini-css-extract-plugin
export var dropdown = "_u7-0";
export var imageWrapper = "_u7-3";
export var itemNameContainer = "_u7-1";
export var productImage = "_u7-2";
export var spinnerWrapper = "_u7-4";